import { StepIndicator } from "./components/stepIndicator";
import { Base } from "./steps.base";

export const Steps = Object.assign(Base, {
    StepIndicator
});
